export const LOG_IN = 'LOG_IN'
export const LOG_OUT = 'LOG_OUT'
export const SET_FAILED_LOGIN = 'SET_FAILED_LOGIN'
export const WAIT_FOR_LOGIN = 'WAIT_FOR_LOGIN'
export const CLEAR_FAILED_LOGIN = 'CLEAR_FAILED_LOGIN'
export const GET_FRIENDS = 'GET_FRIENDS'
export const GET_MINDFILE = 'GET_MINDFILE'
export const SWITCH_MINDFILE = 'SWITCH_MINDFILE'
export const EMPTY_SESSION_COOKIE = 'EMPTY_SESSION_COOKIE'
export const GET_MINDFILE_ITEM = 'GET_MINDFILE_ITEM'
export const UPDATE_MINDFILE_ITEM = 'UPDATE_MINDFILE_ITEM'
export const GET_MINDFILE_ITEMS = 'GET_MINDFILE_ITEMS'
export const GET_MINDFILE_ITEM_DETAILS = 'GET_MINDFILE_ITEM_DETAILS'
export const SET_VIEW_ITEM_STATUS = 'SET_VIEW_ITEM_STATUS'
export const SET_SELECTED_MINDFILE_ITEMS = 'SET_SELECTED_MINDFILE_ITEM'
export const SET_SELECTED_FOLDERS = 'SET_SELECTED_FOLDERS'
export const ADD_FRIEND = 'ADD_FRIEND'
export const REMOVE_FRIEND = 'REMOVE_FRIEND'
export const UPDATE_EMAIL = 'UPDATE_EMAIL'
export const UPDATE_MINDFILE_NAME = 'UPDATE_MINDFILE_NAME'
export const UPDATE_BIRTHDAY = 'UPDATE_BIRTHDAY'
export const UPDATE_LOCATION = 'UPDATE_LOCATION'
export const UPDATE_MINDFILE_PRIVACY_LEVEL = 'UPDATE_MINDFILE_PRIVACY_LEVEL'
export const UPDATE_MINDFILE_GROUP = 'UPDATE_MINDFILE_GROUP'
export const UPDATE_RECEIVE_EMAIL = 'UPDATE_RECEIVE_EMAIL'
export const REMOVE_ITEMS = 'REMOVE_ITEMS'
export const MOVE_ITEMS = 'MOVE_ITEMS'
export const GET_FOLDER_LIST = 'GET_FOLDER_LIST'
export const GET_FOLDERS = 'GET_FOLDERS'
export const GET_FOLDER_DETAILS = 'GET_FOLDER_DETAILS'
export const GET_FOLDER_ITEMS = 'GET_FOLDER_ITEMS'
export const UPDATE_FOLDER = 'UPDATE_FOLDER'
export const UPDATE_FOLDERS = 'UPDATE_FOLDERS'
export const ADD_FOLDER = 'ADD_FOLDER'
export const REMOVE_FOLDER = 'REMOVE_FOLDER'
export const REMOVE_FOLDERS = 'REMOVE_FOLDERS'
export const GET_ITEMS = 'GET_ITEMS'
export const GET_ITEM_LOCATIONS = 'GET_ITEM_LOCATIONS'
export const GET_ITEM_LOCATIONS_BATCH = 'GET_ITEM_LOCATIONS_BATCH'
export const GET_MINDFILE_PHOTOS = 'GET_MINDFILE_PHOTOS'
export const ADD_JOURNAL_POST = 'ADD_JOURNAL_POST'
export const ADD_FAVORITE = 'ADD_FAVORITE'
export const ADD_LINK = 'ADD_LINK'
export const GET_PERSONALITY_DATA = 'GET_PERSONALITY_DATA'
export const GET_PERSONALITY_FACETS = 'GET_PERSONALITY_FACETS'
export const UPDATE_PERSONALITY_ANSWER = 'UPDATE_PERSONALITY_ANSWER'
export const GET_GRATITUDE_DATA = 'GET_GRATITUDE_DATA'
export const UPDATE_GRATITUDE_ANSWER = 'UPDATE_GRATITUDE_ANSWER'
export const GET_GRATITUDE_SCORE = 'GET_GRATITUDE_SCORE'
export const GET_CURRENT_USER_MINDFILES = 'GET_CURRENT_USER_MINDFILES'
export const GET_SPACECAST_SETTINGS = 'GET_SPACECAST_SETTINGS'
export const UPDATE_SPACECAST_SETTINGS = 'UPDATE_SPACECAST_SETTINGS'
export const RESET_PASSWORD = 'RESET_PASSWORD'
export const SET_PASSWORD = 'SET_PASSWORD'
export const LOADING_MINDFILE = 'LOADING_MINDFILE'
export const SET_MINDFILE_PICTURE_UPLOADING = 'SET_MINDFILE_PICTURE_UPLOADING'
export const SET_FACEBOOK_ACCESS_TOKEN = 'SET_FACEBOOK_ACCESS_TOKEN'
export const SET_INSTAGRAM_ACCESS_TOKEN = 'SET_INSTAGRAM_ACCESS_TOKEN'
export const SET_TWITTER_ACCESS_TOKEN = 'SET_TWITTER_ACCESS_TOKEN'
export const SET_TWITTER_ACCESS_SECRET = 'SET_TWITTER_ACCESS_SECRET'
export const SET_TWITTER_ACCESS_PROPS = 'SET_TWITTER_ACCESS_PROPS'

export const GET_USER_VIEW_OPTS = 'GET_USER_VIEW_OPTS'

export const UPDATE_PAGE_VIEW_OPTS = 'UPDATE_PAGE_VIEW_OPTS'
export const USAGE_DATA = 'USAGE_DATA'
export const MULTI_USER_MINDFILES = 'MULTI_USER_MINDFILES'
export const IMPORT_SOURCES = 'IMPORT_SOURCES'
export const SET_AVATAR_READY_AT = 'SET_AVATAR_READY'
